import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import getFileExtension from "@insite/client-framework/Common/Utilities/getFileExtension";
import { isNonEmptyString } from "@insite/client-framework/Common/Utilities/StringUtilities";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setIsBadFile from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetIsBadFile";
import setUploadLimitExceeded from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetUploadLimitExceeded";
import {
    getCountriesDataView,
    getCurrentCountries,
} from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries, {
    loadCurrentCountriesParameter,
} from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import { getHomePageUrl, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import resetBillingAddressFormValidation from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/ResetBillingAddressFormValidation";
import validateBillingAddressForm from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/ValidateBillingAddressForm";
import translate from "@insite/client-framework/Translate";
import {
    AddressFieldDisplayCollectionModel,
    BillToModel,
    CustomerValidationDto,
    StateModel,
} from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CustomerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import FileUpload, { FileUploadPresentationProps } from "@insite/mobius/FileUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import creditCardFormHandler from "@tCentro/Handlers/CENCreditApplicationFormHandler";
import CENCreditCardDollarIcon from "@tCentro/Icons/CENCreditApplicationDollarIcon";
import CreditCardTruckIcon from "@tCentro/Icons/CENCreditApplicationTruckIcon";
import CustomTruckIcon from "@tCentro/Icons/CustomTruckIcon";

import { CreditCardFormRequest } from "@tCentro/Services/CENCreditApplicationFormService";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import React, { useEffect, useRef, useState } from "react";
import { Dispatch, FC } from "react";
import { ResolveThunks } from "react-redux";
import { connect } from "react-redux";

import { AnyAction } from "redux";
import { css } from "styled-components";

import Link from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import set from "lodash/set"
import debounce from "lodash/debounce";
import credAppBussinessTypeHandler from "@tCentro/Handlers/CENCredAppBussinessTypeHandler";
import getSmartyAutocomplete from "@tCentro/Handlers/CENSmartyAutocomplateHandler";

interface OwnProps extends WidgetProps {
    extendedStyles?: CustomerAddressFormFieldStyles;
    fieldDisplay: AddressFieldDisplayCollectionModel;
    validation: CustomerValidationDto;
     fields: {
        [fields.maxFileSize]: number;
    };
}
const enum fields {
    maxFileSize = "maxFileSize",
   
}
const mapStateToProps = (state: ApplicationState) => {
    const countriesDataView = getCountriesDataView(state, loadCurrentCountriesParameter);
    return {
        countries: getCurrentCountries(state),
        homePageUrl: getHomePageUrl(state),
    };
};

const mapDispatchToProps = {
    loadCurrentCountries,
    creditCardFormHandler,
    setIsBadFile,
    setUploadLimitExceeded,
    credAppBussinessTypeHandler,
    getSmartyAutocomplete,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;
export interface CENCreditCardAppFormStyles {
    containerCustom?: GridContainerProps;
    companyName?: GridItemProps;
    companyNameCustomText?: TextFieldPresentationProps;
    address?: GridItemProps;
    addressText?: TextFieldPresentationProps;
    cityGridItemCustom?: GridItemProps;
    cityTextCustom?: TextFieldPresentationProps;
    stateGridItemCustom?: GridItemProps;
    stateSelectCustom?: SelectPresentationProps;
    postalCodeGridItemCustom?: GridItemProps;
    postalCodeTextCustom?: TextFieldPresentationProps;
    phoneGridItemCustom?: GridItemProps;
    phoneTextCustom?: TextFieldPresentationProps;
    faxGridItemCustom?: GridItemProps;
    faxTextCustom?: TextFieldPresentationProps;
    emailGridItemCustom?: GridItemProps;
    emailTextCustom?: TextFieldPresentationProps;
    bradstreetGridItem?: GridItemProps;
    bradstreetText?: TextFieldPresentationProps;
    sicCodeGridItem?: GridItemProps;
    sicCodeTextCustom?: TextFieldPresentationProps;
    apContactItem?: GridItemProps;
    apContactText?: TextFieldPresentationProps;
    checkingAccount1?: GridItemProps;
    checkingAccount1Text?: TextFieldPresentationProps;

    checkingAccount2?: GridItemProps;
    checkingAccount2Text?: TextFieldPresentationProps;

    loanAccount1?: GridItemProps;
    loanAccount1Text?: TextFieldPresentationProps;

    loanAccount2?: GridItemProps;
    loanAccount2Text?: TextFieldPresentationProps;

    bankContact?: GridItemProps;
    bankContactText?: TextFieldPresentationProps;

    bankPhone?: GridItemProps;
    bankPhoneText?: TextFieldPresentationProps;
    submitButtonCustom?: ButtonPresentationProps;
    submitError?: InjectableCss;
    checkboxGridItem?: GridItemProps;
    checkboxGridItemWithError?: GridItemProps;
    invoiceTermsGridItem?: GridItemProps;
    innerContainer?: InjectableCss;
    fileUploader?: FileUploadPresentationProps;
    fileUploaderContainer?: InjectableCss;
    checkboxStyle?: InjectableCss;
    address2?: GridItemProps;
    addressList?: InjectableCss;
    modalWrapper?: InjectableCss;
    okButton?: ButtonPresentationProps;
    modalStyle?: ModalPresentationProps;
     centeringWrapper?: InjectableCss;
      spinner?: LoadingSpinnerProps;
      title?:InjectableCss;
      checkboxWrapper?:InjectableCss;
}

export const CenCreditCardAppFormStyles: CENCreditCardAppFormStyles = {

     centeringWrapper: {
            css: css`
                height: 100px;
                width: 100%;
                display: flex;
                align-items: center;
            `,
        },
        title:{
            css: css`
            width:100%;
               font-size:56px;
               margin-left: 15px;
               margin-bottom: 13px;
        margin-top: 39px !important;
         ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                         
                        `,
                        css`
                           
                        `,
                        css`
                           font-size:45px;
                        `,
                        null,
                        null,
                    ])}
            `,
        },
         spinner: {
                css: css`
                    margin: 0 auto;
                `,
            },
    modalStyle: {
        cssOverrides: {
            modalContainer: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            > div[aria-labelledby="modalTitle"] {
                                height: auto !important;
                            }
                        `,
                        css`
                            > div[aria-labelledby="modalTitle"] {
                                height: auto !important;
                            }
                        `,
                        css`
                            > div[aria-labelledby="modalTitle"] {
                                height: auto !important;
                            }
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
    modalWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 32px;
                    `,
                    css`
                        gap: 32px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    okButton: {
        css: css`
            border-radius: 24px;
            padding: 12px 24px;
            line-height: 24px;
            font-size: 18px;
            font-weight: 600;
            border: none;
            align-self: end;
            span {
                font-weight: 600 !important;
                font-size: 18px !important;
                line-height: 24px !important;
                font-family: Poppins !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        max-height: 48px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    `,
                    css`
                        width: 100%;
                        max-height: 48px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    `,
                    css`
                        max-height: 48px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    `,
                    css`
                        max-height: 48px;
                        max-width: 97px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    `,
                    css`
                        max-height: 48px;
                        max-width: 97px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    `,
                ])}
        `,
    },
    checkboxStyle: {
        css: css`
            min-height: 22px;
            label {
                font-size: 22px !important;
                padding-left:8px !important;
            }
            span {
                width: 20px;
                height: 20px;
                border:2px solid #262525;
            }
            svg {
                width: 20px;
                height: 20px;
            }
        `,
    },
    companyName: { width: 12 },
    address: { 
        width: 12, 
        css: css`
            position: relative;
        ` 
    },
    addressList: {
        css: css`
            position: absolute;
            top: 85px;
            left: 0;
            background: white;
            width: calc(100% - 30px);
            z-index: 999;
            padding: 5px 0 0;
            margin: 0 15px;
            border: 1px solid #ebebeb;
            border-radius: 24px;
            height: 200px;
            overflow: auto;
            li {
                padding: 7px 15px;
                border-bottom: 1px solid #ebebeb;
                cursor: pointer;
                &:hover {
                    background-color: #f2f2f2;
                }
            }
        `
    },
    cityGridItemCustom: { width: [12, 12, 12, 6, 6] },
    stateGridItemCustom: { width: [12, 12, 6, 2, 2] },
    postalCodeGridItemCustom: { width: [12, 12, 6, 4, 4] },
    phoneGridItemCustom: { width: [12, 12, 12, 6, 6] },
    faxGridItemCustom: { width: [12, 12, 12, 6, 6] },
    emailGridItemCustom: { width: 12 },
    bradstreetGridItem: { width: 12 },
    sicCodeGridItem: { width: [12, 12, 12, 6, 6] },
    apContactItem: { width: 12 },
    checkingAccount1: { width: [12, 12, 12, 6, 6] },
    checkingAccount2: { width: [12, 12, 12, 6, 6] },
    loanAccount1: { width: [12, 12, 12, 6, 6] },
    loanAccount2: { width: [12, 12, 12, 6, 6] },
    bankContact: { width: [12, 12, 12, 6, 6] },
    bankPhone: { width: [12, 12, 12, 6, 6] },
     address2: { width: 12 ,
        css: css` 
        padding-top: 0px !important;  
        `
     },
    checkboxGridItem: {
        width: 6,
        css: css`  
        max-width: 20%;
    flex-basis: 20%;
    gap:16px;
    align-items: flex-start;
    margin-top:20px !important;;
    padding-bottom: 0px !important;
       flex-direction: column;
       margin-left:15px !important;
     @media only screen 
  and (min-width: 768px) 
  and (max-width: 820px)  {
   max-width: 30% !important;
    flex-basis: 30% !important;
  
}

    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                flex-direction: column;
                  max-width: 100%;
    flex-basis: 100%;
            `,
            css`
                  flex-direction: column;
                  max-width: 100%;
    flex-basis: 100%;
            `,
            css`
             max-width: 25%;
    flex-basis: 25%;
            `,
            css`
            max-width: 25%;
    flex-basis: 25%;
            `,
            null,
        ])}
    label{
    margin-left: 0px !important;
    }
    button{
    margin-left:10px;
    }
    div[class^="UploadWrapper"]{
   
      ${({ theme }: { theme: BaseTheme }) =>
          breakpointMediaQueries(theme, [
              css`
                  width: 100%;
              `,
              css`
                  width: 100%;
              `,
              css``,
              null,
              null,
          ])}
    align-items: center;
    div[class^="FormFieldStyle"]{
        width:330px;
        max-width: 330px;
         ${({ theme }: { theme: BaseTheme }) =>
          breakpointMediaQueries(theme, [
              css`
                  width: 100%;
                  max-width:100%
              `,
              css`
                  width: 100%;
                   max-width:100%;
              `,
              css``,
              null,
              null,
          ])}
    }
     div[class^="FileUploadStyle"]{ {
                width: 100%;
                box-sizing: border-box;
                font-family: inherit;
                font-size: 15px;
                outline: 0px;
                appearance: none;
                color: inherit;
                background-color: #f2f2f2 !important;
                border-radius: 24px !important;
                padding:0px 30px 0px 10px;
            }
                div[class^="AppearanceTransition"]{
                input{
               height: 35px !important;
    margin-top: 2px;
     }
    button{
    height: 37px !important;
    margin-top: 1px;
    
    }
                
                }
    span[id^="orderUploadFileUpload-label"]{
    
     color: black !important;
    }
    }
    div[class^="ButtonWrapper"]{
    label[for^="orderUploadFileUpload"]{
     padding: 7px 21px !important;
    ${({ theme }: { theme: BaseTheme }) =>
          breakpointMediaQueries(theme, [
              css`
                 margin-top:50px;
              `,
              css`
                  margin-top:50px;
              `,
              css``,
              null,
              null,
          ])};
    span{
    color: #8F0446;
    }
    }

    margin-left: 10px !important;
     label{
    
    //  margin-top: 0px !important;
    }
    }
   
    `,
    },
    checkboxGridItemWithError: {
        
        css: css`  
        max-width: 20%;
    flex-basis: 20%;
    gap:16px;
    align-items: flex-start;
    margin-top:20px !important;
      margin-left:15px !important;
    padding-bottom: 0px !important;
     flex-direction: column;
      div[class^="ButtonWrapper"]{
    label[for^="orderUploadFileUpload"]{
     padding: 7px 21px !important;}}
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                flex-direction: column;
                 max-width: 100%;
    flex-basis: 100%;
            `,
            css`
                flex-direction: column;
                  max-width: 100%;
    flex-basis: 100%;
            `,
            css`
              max-width: 25%;
    flex-basis: 25%;
            `,
            css`
              max-width: 25%;
    flex-basis: 25%;
            `,
            null,
        ])}
    label{
    margin-left: 0px !important;
    margin-top:0px !important;
    }
    button{
    margin-left:10px;
    }
    div[class^="UploadWrapper"]{
   
      ${({ theme }: { theme: BaseTheme }) =>
          breakpointMediaQueries(theme, [
              css`
                  width: 100%;
              `,
              css`
                  width: 100%;
              `,
              css``,
              null,
              null,
          ])};
    align-items: center;
    max-width:500px !important;
    width: 500px;
     div[class^="FileUploadStyle"]{ 
     {
                width: 100%;
                box-sizing: border-box;
                font-family: inherit;
                font-size: 15px;
                outline: 0px;
                appearance: none;
                color: inherit;
                background-color: #f2f2f2 !important;
                border-radius: 24px !important;
                padding: 0px 10px;
               
            }
                input[id="orderUploadFileUpload"]{
               padding-right: 55px !important;
               } 
                div[class^="AppearanceTransition"]{
                input{
               height: 35px !important;
    margin-top: 2px;
     }
    button{
    height: 37px !important;
    margin-top: 1px;
    
    }
                
                }
    span[id^="orderUploadFileUpload-label"]{
    
    //  display: none;
    }
    }
    div[class^="ButtonWrapper"]{
    label[for^="orderUploadFileUpload"]{
        margin-top: 0px !important;
    span{
    color: #8F0446;
    }
    }

    margin-left: 10px !important;
     label{
    
    //  margin-top: 0px !important;
    }
    }
   
    `,
    },
    //     fileUploaderContainer:{
    // css: css`
    // div[class^="GridOffset"]{
    // display: flex;
    // flex-direction: column;
    // border: 1px solid red;
    // width:50%;
    //     }

    // `
    //     },
    fileUploader: {
        buttonProps: {
            variant: "secondary",
        },
    },
    invoiceTermsGridItem: {
        width: 12,
        css: css`
            max-width: 100%;
            flex-basis: 100%;
            align-items: center;
            padding: 40px !important;
            background-color: #eef3f0 !important;
            display: flex;
            gap: 24px;
            margin-left: 15px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css``,
                    null,
                    null,
                ])}
        `,
    },
    innerContainer: {
        css: css`
            display: flex;
            align-items: center;
            gap: 12px;
        `,
    },
    submitError:{
css:css`
 display: flex;
            align-items: center;
            width: 100%;
            justify-content: end;
            margin-right: 20px !important;
`
    },
    submitButtonCustom: {
        css: css`
            display: flex;
            align-items: center;
            width: 100%;
            justify-content: end;
            margin-bottom: 64px;
            margin-top: 25px;
            margin-right: 20px;
        `,
    },
    containerCustom: {
        css: css`
            label {
                font-family: Poppins;
                font-size: 14px;
                font-weight: 600;
                line-height: 16px;
                padding-left: 24px;
                min-height: auto;
                color: rgb(38, 37, 37);
            }
            input[type="text"] {
                width: 100%;
                box-sizing: border-box;
                font-family: inherit;
                font-size: 15px;
                outline: 0px;
                appearance: none;
                color: inherit;
                background-color: #f2f2f2 !important;
                border-radius: 24px !important;
                padding: 0px 24px !important;
            }
            select {
                width: 100%;
                box-sizing: border-box;
                font-family: inherit;
                font-size: 15px;
                outline: 0px;
                appearance: none;
                color: inherit;
                background-color: #f2f2f2 !important;
                border-radius: 24px !important;
                padding: 0 10px 0 24px  !important;
            }
            //    div[class^="GridOffset"]:first-child{
            //    display: block;
            //    }
        `,
    },
};
export interface BillingAddressFormStyles {
    formFields?: CustomerAddressFormFieldStyles;
}

export const billingAddressFormStyles: BillingAddressFormStyles = {};

/**
 * @deprecated Use billingAddressFormStyles instead.
 */
export const oneTimeAddressFormStyles = billingAddressFormStyles;
const styles = billingAddressFormStyles;

const StyledForm = getStyledWrapper("form");
const StyledFieldSet = getStyledWrapper("fieldset");
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.(?!usa$)\\w+([-.]\\w+)*", "i");
const CENCreditCardAppForm = ({
    extendedStyles,
    fieldDisplay,
    validation,
    loadCurrentCountries,
    countries,
    creditCardFormHandler,
    fields,
    homePageUrl,
    credAppBussinessTypeHandler,
    getSmartyAutocomplete,
}: Props) => {
    const [styles] = React.useState(() => mergeToNew(CenCreditCardAppFormStyles, extendedStyles));
    const emailRequiredFieldMessage = siteMessage("CreditCardApp_EmailForInvoice_Required");
    const emailFieldMessage = siteMessage("Enter Valid Email Id.");
     const emailRequiredFieldMessagePer = siteMessage("Email Id Required.");
    const emailFieldMessagePer = siteMessage("CreditCardApp_EmailForInvoice_ValidEmail");
    const uploadFileMessageEPA = siteMessage("Tax Exemption Certificate Required");
    const [perName, setPerName] = useState("");
    const [perNameError, setPerNameError] = useState("");
    const [perEmail, setPerEmail] = useState("");
    const [perEmailError, setPerEmailError] = useState("");
    const [isAddress2Opened, setIsAddress2Opened] = useState(false);
    const [isBankAddress2Opened, setIsBankAddress2Opened] = useState(false);
    const[isshippingAddress2Opened, setIsShippingAddress2Opened] = useState(false);
    const [bTaddress1, setbTAddress1] = useState("");
    const [bTaddress1Error, setbTAddress1Error] = useState("");
    const [address2, setAddress2] = useState("");
    const[shippingAddress2, setShippingAddress2] = useState("");
    const [bankAddress2, setBankAddress2] = useState("");
    const [bTcompanyName, setbTCompanyName] = useState("");
    const [bTpostalCode, setbTpostalCode] = useState("");
    const [bTpostalCodeError, setbTpostalCodeError] = useState("");
    const [address2Error, setAddress2Error] = useState("");
    const [bTcity, setbTCityChange] = useState("");
    const [bTcityError, setbTCityError] = useState("");
    const [bTstateError, setbTStateError] = useState("");
    const [states, setStates] = useState<StateModel[]>([]);
    const [bTstate, setbTState] = useState<any>();
    const [businessType,setBussinesstype]=useState<any>();
    const [formErrors, setFormErrors] = useState<any>("");
    const [emailforInvoice, setEmailforInvoice] = useState("");
    const [emailInvoiceError, setEmailInvoiceError] = useState("");
    const [fax, setFax] = useState("");
    const [companyNameError, setCompanyNameError] = useState("");
    const [billingPhone, setBillingPhone] = useState("");
    const [billingPhoneError, setBillingPhoneError] = useState("");
    const [billingApContact, setBillingApContact] = useState("");
    const [billingApContactError, setBillingApContactError] = useState("");
    const [billingSicCode, setBillingSicCode] = useState("");
    const [billingDnBNumber, setBillingDnBNumber] = useState("");
     const [billingDnBNumberError, setBillingDnBNumberError] = useState("");
    const [bTaddressAutocomplete, setbTAddressAutocomplete] = useState<any[]>([]);
      const [isLoading, setIsLoading] = useState(false);
    // Shipping info states
    const [shippingCompanyName, setShippingCompanyName] = useState("");
    const [shippingCompanyNameError, setShippingCompanyNameError] = useState("");

    const [shippingAddress, setShippingAddress] = useState("");
    const [shippingAddressError, setShippingAddressError] = useState("");
    const [shippingAddressAutocomplete, setShippingAddressAutocomplete] = useState<any[]>([]);

    const [shippingCity, setShippingCity] = useState("");
    const [shippingCityError, setShippingCityError] = useState("");

    const [shippingState, setShippingState] = useState<any>();
    const [shippingStateError, setShippingStateError] = useState("");

    const [shippingPostalCode, setShippingPostalCode] = useState("");
    const [shippingPostalCodeError, setShippingPostalCodeError] = useState("");

    const [shippingPhone, setShippingPhone] = useState("");
    const [shippingPhoneError, setShippingPhoneError] = useState("");

    const [shippingFax, setShippingFax] = useState(""); // optional

    // Bank address autocomplete state
    const [bankAddressAutocomplete, setBankAddressAutocomplete] = useState<any[]>([]);

    //  State declarations for Bank Reference form

    const [bankName, setBankName] = useState("");
    const [bankAddress, setBankAddress] = useState("");
    const [bankCity, setBankCity] = useState("");
    const [bankCityError, setBankCityError] = useState("");
    const [bankState, setBankState] = useState<any>(); // or adjust type if needed
    const [bankPostalCode, setBankPostalCode] = useState("");
    const [checkingAccount1, setCheckingAccount1] = useState("");
    const [checkingAccount2, setCheckingAccount2] = useState("");
    const [loanAccount1, setLoanAccount1] = useState("");
    const [loanAccount2, setLoanAccount2] = useState("");
    const [bankContact, setBankContact] = useState("");
    const [bankPhone, setBankPhone] = useState("");
    const [bussinesTypes, setBusinessTypes] = useState<any[]>([]);

    // state declarations for Trade Reference form
    const [firmName1, setFirmName1] = useState("");
    const [contact1, setContact1] = useState("");
    const [acct1, setAcct1] = useState("");

    const [firmName2, setFirmName2] = useState("");
    const [contact2, setContact2] = useState("");
    const [acct2, setAcct2] = useState("");

    const [firmName3, setFirmName3] = useState("");
    const [contact3, setContact3] = useState("");
    const [acct3, setAcct3] = useState("");

    const [firmName1Error, setFirmName1Error] = useState("");
    const [acct1Error, setAcct1Error] = useState("");
    const [contact1Error, setContact1Error] = useState("");
    const [firmName2Error, setFirmName2Error] = useState("");
    const [contact2Error, setContact2Error] = useState("");
    const [acct2Error, setAcct2Error] = useState("");
    const [firmName3Error, setFirmName3Error] = useState("");
    const [contact3Error, setContact3Error] = useState("");
    const [acct3Error, setAcct3Error] = useState("");
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [fileEPA, setFileEPA] = useState<any>(null);
    const [isTaxExempt, setIsTaxExempt] = useState(false);
     const [isReseller, setIsReseller] = useState(false);
    const fileUploadRef = useRef({ value: "" } as HTMLInputElement);
    const [FileUploadEPAerror, setFileUploadEPAerror] = React.useState(uploadFileMessageEPA);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const hasAnyError = () => {
    const errors = [
        perNameError,
        perEmailError,
        bTaddress1Error,
        address2Error,
        bTcityError,
        bTstateError,
        bTpostalCodeError,
        companyNameError,
        emailInvoiceError,
        billingPhoneError,
        billingApContactError,
        billingDnBNumberError,
        shippingCompanyNameError,
        shippingAddressError,
        shippingCityError,
        shippingStateError,
        shippingPostalCodeError,
        shippingPhoneError,
        bankCityError,
        firmName1Error,
        acct1Error,
        contact1Error,
        firmName2Error,
        contact2Error,
        acct2Error,
        firmName3Error,
        contact3Error,
        acct3Error,
       isTaxExempt? FileUploadEPAerror:"", // include if you want file upload errors too
    ];

    return errors.some(error => typeof error === "string" && error.trim() !== "");
};

    const checkboxGridItemFinal =
        (fileEPA && !!FileUploadEPAerror) || (!fileEPA && FileUploadEPAerror === uploadFileMessageEPA && isSubmitted)
            ? { ...styles.checkboxGridItemWithError }
            : { ...styles.checkboxGridItem };
    const handlePerNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPerName(e.target.value);
        validatePerName(e.target.value);
    };
    const validatePerName = (value: string) => {
        const isValid = isNonEmptyString(value);
        setPerNameError(!isValid ? translate(" Name is required.") : "");
        return isValid;
    };
    const validatePerEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessagePer : emailRegexp.test(email) ? "" : emailFieldMessagePer;
        setPerEmailError(String(errorMessage));
        return !errorMessage;
    };
    const handlePerEmailChange = (email: string) => {
        validatePerEmail(email);
        setPerEmail(email);
    };

    const validateShippingCompanyName = (value: string) => {
        const isValid = isNonEmptyString(value);
        setShippingCompanyNameError(!isValid ? translate("Company Name is required.") : "");
        return isValid;
    };

    // Create debounced function for Smarty autocomplete (500ms delay)
    const debouncedShippingAutocomplete = useRef(
        debounce((searchValue: string) => {
            getSmartyAutocomplete({
                search: searchValue.trim(),
                onSuccess: (result: any) => {
                    setShippingAddressAutocomplete(result);
                },
            });
        }, 500)
    ).current;

    // Create debounced function for Smarty autocomplete for billing address (500ms delay)
    const debouncedBTAutocomplete = useRef(
        debounce((searchValue: string) => {
            getSmartyAutocomplete({
                search: searchValue.trim(),
                onSuccess: (result: any) => {
                    setbTAddressAutocomplete(result);
                },
            });
        }, 500)
    ).current;

    // Create debounced function for Smarty autocomplete for bank address (500ms delay)
    const debouncedBankAutocomplete = useRef(
        debounce((searchValue: string) => {
            getSmartyAutocomplete({
                search: searchValue.trim(),
                onSuccess: (result: any) => {
                    setBankAddressAutocomplete(result);
                },
            });
        }, 500)
    ).current;

    const validateShippingAddress = (value: string) => {
        const isValid = isNonEmptyString(value);
        setShippingAddressError(!isValid ? translate("Address is required.") : "");
        
        // Call Smarty autocomplete handler if value is provided
        if (isValid && value.trim().length >= 3) {
            debouncedShippingAutocomplete(value);
        } else {
            setShippingAddressAutocomplete([]);
        }
        
        return isValid;
    };

    const updateShippingAddress = (address: any) => {

        const selectedState = selectedCountry?.states?.find(s => s.id === address.stateId);

        setShippingState(selectedState);
        setShippingAddressAutocomplete([]); // Clear suggestions after selection
        setShippingAddress(address.street_line);
        setShippingAddressError("")
        setShippingPostalCode(address.zipcode)
        setShippingPostalCodeError("")
        setShippingCity(address.city)
        setShippingCityError("")
        if (address.secondary) {
            setIsShippingAddress2Opened(true)
            setShippingAddress2(address.secondary)
        } else {
            setIsShippingAddress2Opened(false)
            setShippingAddress2("")
        }
        // setShippingAddress(address);
        // validateShippingAddress(address);
    }

    const updateBTAddress = (address: any) => {
        const selectedState = selectedCountry?.states?.find(s => s.id === address.stateId);

        setbTState(selectedState);
        setbTAddressAutocomplete([]); // Clear suggestions after selection
        setbTAddress1(address.street_line);
        setbTAddress1Error("")
        setbTpostalCode(address.zipcode)
        setbTpostalCodeError("")
        setbTCityChange(address.city)
        setbTCityError("")
        if (address.secondary) {
            setIsAddress2Opened(true)
            setAddress2(address.secondary)
            setAddress2Error("")
        } else {
            setIsAddress2Opened(false)
            setAddress2("")
        }
    }

    const validateShippingCity = (value: string) => {
        const isValid = isNonEmptyString(value);
        setShippingCityError(!isValid ? translate("City is required.") : "");
        return isValid;
    };

    const validateShippingState = (stateId: any) => {
        const isValid = isNonEmptyString(stateId);
        setShippingStateError(!isValid ? translate("State is required.") : "");
        return isValid;
    };

    const validateShippingPostalCode = (value: string) => {
         const postalCodeValid = isNonEmptyString(value);
        
          const checkIfNotNumber = value && !Number(value);
                const postalCodeError = checkIfNotNumber ? translate("Please enter numbers only") : "";
                setShippingPostalCodeError(!postalCodeValid ? translate("Postal Code is required.") : postalCodeError);
        return postalCodeValid || checkIfNotNumber;
    };

    const validateShippingPhone = (value: string) => {
        const isValid = isNonEmptyString(value); // or add phone regex
        setShippingPhoneError(!isValid ? translate("Phone Number is required.") : "");
        return isValid;
    };

    const handleShippingCompanyNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setShippingCompanyName(e.target.value);
        validateShippingCompanyName(e.target.value);
    };

    const handleShippingAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.value.includes("@")) {
            setShippingAddress(e.target.value);
            validateShippingAddress(e.target.value);
        }
    };

    const handleShippingCityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setShippingCity(e.target.value);
        validateShippingCity(e.target.value);
    };

    const handleShippingStateChange: SelectProps["onChange"] = event => {
        const selectedState = selectedCountry?.states?.find(s => s.id === event.target.value);
        setShippingState(selectedState);
        validateShippingState(event.target.value);
    };
    const handleShippingPostalCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setShippingPostalCode(e.target.value);
        validateShippingPostalCode(e.target.value);
    };

    const handleShippingPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setShippingPhone(e.target.value);
        validateShippingPhone(e.target.value);
    };

    const handleShippingFaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setShippingFax(e.target.value); // optional, so no validation
    };

    useEffect(() => {
        if (!countries) {
            loadCurrentCountries(); // remove countries call on initial load
        }
    }, [countries]);
    const selectedCountry = countries?.find(c => c.abbreviation === "US");

    useEffect(() => {
        setStates(selectedCountry?.states || []);
    }, [selectedCountry]);
    useEffect(() => {
        credAppBussinessTypeHandler({onSuccess(result) {
                        const filteredResult = result.filter(
                (type:any) => !type.startsWith("Retrieving data")
            );

             setBusinessTypes(filteredResult);
        }})
       
    }, []);

    const handleStateChange: SelectProps["onChange"] = event => {
        const selectedState = selectedCountry?.states?.find(s => s.id === event.target.value);
        setbTState(selectedState);
        bTvalidateState(event.target.value);
    };
    const bTvalidateState = (stateId: any) => {
        const stateValidFn = isNonEmptyString(stateId);
        setbTStateError(!stateValidFn ? translate("State is required.") : "");
        return stateValidFn;
    };

    const handleFaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFax(e.target.value); // optional, so no validation
    };

    const handleBillingPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBillingPhone(e.target.value);
        validateBillingPhone(e.target.value);
    };

    const validateBillingPhone = (value: string) => {
        const isValid = isNonEmptyString(value); // or add phone regex
        setBillingPhoneError(!isValid ? translate("Phone Number is required.") : "");
        return isValid;
    };
    const handleBillingApContactChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBillingApContact(e.target.value);
        validateBillingApContact(e.target.value);
    };

    const validateBillingApContact = (value: string) => {
       const isValid = isNonEmptyString(value); // or add phone regex
        setBillingApContactError(!isValid ? translate("AP Contact is required.") : "");
        return isValid;
    };
    const handleBillingSicCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBillingSicCode(e.target.value);
    };

    const handleBillingDnBNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBillingDnBNumber(e.target.value);
        validateBillingDnBNumber(e.target.value);
    };

const validateBillingDnBNumber = (value: string) => {
        const checkIfNotNumber = value && !Number(value);
        const dunCodeError = checkIfNotNumber ? translate("Please enter numbers only") : "";
        setBillingDnBNumberError(dunCodeError);
        
        return  !dunCodeError;
    };

    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailInvoiceError(String(errorMessage));
        return !errorMessage;
    };
    const emailChangeHandler = (email: string) => {
        validateEmail(email);
        setEmailforInvoice(email);
    };
    const validateForm = () => {
        const bTcompanyNameValid = bTvalidateCompanyName(bTcompanyName);
        const bTstateValid = bTvalidateState(bTstate?.id);
        const bTcityValid = bTValidateCity(bTcity);
        const bTaddress1Valid = bTvalidateAddress1(bTaddress1);
        const emailValid = validateEmail(emailforInvoice);
        const postalCodeValid = bTValidatePostalCode(bTpostalCode);
        const bTphoneValid = validateBillingPhone(billingPhone);
        const apContactValid = validateBillingApContact(billingApContact);

        const shippingCompanyNameValid = validateShippingCompanyName(shippingCompanyName);
        const shippingAddressValid = validateShippingAddress(shippingAddress);
        const shippingCityValid = validateShippingCity(shippingCity);
        const shippingStateValid = validateShippingState(shippingState?.id);
        const shippingPostalCodeValid = validateShippingPostalCode(shippingPostalCode);
        const shippingPhoneValid = validateShippingPhone(shippingPhone);

        const bankCityValid = validateBankCity(bankCity);

        const acct1Error = validateAcct1(acct1);
        const contact1Error = validateContact1(contact1);
        const firmName1Error = validateFirmName1(firmName1);
        const firmName2Error = validateFirmName2(firmName2);
        const contact2Error = validateContact2(contact2);
        const acct2Error = validateAcct2(acct2);
        const firmName3Error = validateFirmName3(firmName3);
        const contact3Error = validateContact3(contact3);
        const acct3Error = validateAcct3(acct3);
        const perEmailValid = validatePerEmail(perEmail);
        const perNameValid = validatePerName(perName);
     const isEPAFileValid = isTaxExempt ? validateUploadedFileEPA(fileEPA) : true;
     const isDunnValid=(billingDnBNumber !== "")? validateBillingDnBNumber(billingDnBNumber):true;
        return (
            bTcompanyNameValid &&
            bTstateValid &&
            bTcityValid &&
            bTaddress1Valid &&
            shippingCompanyNameValid &&
            shippingAddressValid &&
            shippingCityValid &&
            shippingStateValid &&
            shippingPostalCodeValid &&
            shippingPhoneValid &&
            emailValid &&
            postalCodeValid &&
            bTphoneValid &&
            apContactValid &&
            bankCityValid &&
            acct1Error &&
            contact1Error &&
            firmName1Error &&
            perEmailValid &&
            perNameValid &&
            isEPAFileValid&&
            firmName2Error &&
            contact2Error &&
            acct2Error &&
            firmName3Error 
            && contact3Error &&
            acct3Error && isDunnValid
        );
    
        
    };
    const bThandleAddressChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        if (!event.currentTarget.value.includes("@")) {
            setbTAddress1(event.currentTarget.value);
            bTvalidateAddress1(event.currentTarget.value);
        }
    };
      const handleAddress2Change = (event: React.ChangeEvent<HTMLInputElement>) => {
            if (!event.currentTarget.value.includes("@")) {
                setAddress2(event.currentTarget.value);
                validateAddress2(event.currentTarget.value);
            }
        };
        const handleShippingAddress2Change = (event: React.ChangeEvent<HTMLInputElement>) => {
            if (!event.currentTarget.value.includes("@")) {
                setShippingAddress2(event.currentTarget.value);
            }
        };
         const handleBankAddress2Change = (event: React.ChangeEvent<HTMLInputElement>) => {
            if (!event.currentTarget.value.includes("@")) {
                setBankAddress2(event.currentTarget.value);
            }
        };
          const validateAddress2 = (address2: string) => {
                const address2Valid = isNonEmptyString(address2);
                setAddress2Error(!address2Valid ? translate("Address is required.") : "");
                return address2Valid;
            };
    const bThandleCityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setbTCityChange(event.currentTarget.value);
        bTValidateCity(event.currentTarget.value);
    };
    const bTValidateCity = (bTcity: string) => {
        const cityValid = isNonEmptyString(bTcity);
        setbTCityError(!cityValid ? translate("City is required.") : "");
        return cityValid;
    };
    const bTValidatePostalCode = (bTpostalCode: string) => {
        const postalCodeValid = isNonEmptyString(bTpostalCode);
        
          const checkIfNotNumber = bTpostalCode && !Number(bTpostalCode);
                const postalCodeError = checkIfNotNumber ? translate("Please enter numbers only") : "";
                setbTpostalCodeError(!postalCodeValid ? translate("Postal Code is required.") : postalCodeError);
        return postalCodeValid || checkIfNotNumber;
    };
    const bThandlePostalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setbTpostalCode(event.currentTarget.value);
        bTValidatePostalCode(event.currentTarget.value);
    };
    const bTvalidateAddress1 = (address1: string) => {
        const address1Valid = isNonEmptyString(address1);
        setbTAddress1Error(!address1Valid ? translate("Address is required.") : "");
        
        // Call Smarty autocomplete handler if value is provided
        if (address1Valid && address1.trim().length >= 3) {
            debouncedBTAutocomplete(address1);
        } else {
            setbTAddressAutocomplete([]);
        }
        
        return address1Valid;
    };
    const bThandleCompanyNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setbTCompanyName(event.currentTarget.value);
        bTvalidateCompanyName(event.currentTarget.value);
    };
    const bTvalidateCompanyName = (address1: string) => {
        const compnayNameValid = isNonEmptyString(address1);
        setCompanyNameError(!compnayNameValid ? translate("Company Name is required.") : "");
        return compnayNameValid;
    };

    // bank Prefernce fields

    const validateBankCity = (value: string) => {
        const bankCityValid = isNonEmptyString(value);
        setBankCityError(!bankCityValid ? translate(" Bank City Name is required.") : "");

        return bankCityValid;
    };
    const handleBankStateChange: SelectProps["onChange"] = event => {
        const selectedState = selectedCountry?.states?.find(s => s.id === event.target.value);
        setBankState(selectedState);
    };


    const handleBankNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBankName(e.target.value);
    };

    const validateBankAddress = (value: string) => {
        const isValid = isNonEmptyString(value);
        
        // Call Smarty autocomplete handler if value is provided
        if (isValid && value.trim().length >= 3) {
            debouncedBankAutocomplete(value);
        } else {
            setBankAddressAutocomplete([]);
        }
        
        return isValid;
    };

    const updateBankAddress = (address: any) => {
        const selectedState = selectedCountry?.states?.find(s => s.id === address.stateId);

        setBankState(selectedState);
        setBankAddressAutocomplete([]); // Clear suggestions after selection
        setBankAddress(address.street_line);
        setBankPostalCode(address.zipcode);
        setBankCity(address.city);
        if (address.secondary) {
            setIsBankAddress2Opened(true);
            setBankAddress2(address.secondary);
        } else {
            setIsBankAddress2Opened(false);
            setBankAddress2("");
        }
    };

    const handleBankAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.value.includes("@")) {
            setBankAddress(e.target.value);
            validateBankAddress(e.target.value);
        }
    };



    const handleBankCityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBankCity(e.target.value);
        validateBankCity(e.target.value);
    };

 

    const handleBankPostalCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBankPostalCode(e.target.value);
    };

    const handleCheckingAccount1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCheckingAccount1(e.target.value);
    };

    const handleCheckingAccount2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCheckingAccount2(e.target.value);
    };

    const handleLoanAccount1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLoanAccount1(e.target.value);
    };

    const handleLoanAccount2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLoanAccount2(e.target.value);
    };

    const handleBankContactChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBankContact(e.target.value);
    };

    const handleBankPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBankPhone(e.target.value);
    };

    // trade reference form handlers
    const handleFirmName1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirmName1(e.target.value);
        validateFirmName1(e.target.value);
    };
    const validateFirmName1 = (value: string) => {
        const isValid = isNonEmptyString(value);
        setFirmName1Error(!isValid ? translate("Firm name 1 is required.") : "");
        return isValid;
    };

    const handleFirmName2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirmName2(e.target.value);
        validateFirmName2(e.target.value);
    };
    const handleFirmName3Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirmName3(e.target.value);
        validateFirmName3(e.target.value);
    };
    const validateFirmName3 = (value: string) => {
        const isValid = isNonEmptyString(value);
        setFirmName3Error(!isValid ? translate("Firm name 3 is required.") : "");
        return isValid;
    };
    const validateFirmName2 = (value: string) => {
        const isValid = isNonEmptyString(value);
        setFirmName2Error(!isValid ? translate("Firm name 2 is required.") : "");
        return isValid;
    };
    const handleaccount2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAcct2(e.target.value);
        validateAcct2(e.target.value);
    };
    const validateAcct2 = (value: string) => {
        const isValid = isNonEmptyString(value);
        setAcct2Error(!isValid ? translate("Account 2 is required.") : "");
        return isValid;
    };
    const handleContact2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setContact2(e.target.value);
        validateContact2(e.target.value);
    };
    const validateContact2 = (value: string) => {
        const isValid = isNonEmptyString(value);
        setContact2Error(!isValid ? translate("Contact 2 is required.") : "");
        return isValid;
    };
    const handleaccount3Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAcct3(e.target.value);
        validateAcct3(e.target.value);
    };
    const validateAcct3 = (value: string) => {
        const isValid = isNonEmptyString(value);
        setAcct3Error(!isValid ? translate("Account 3 is required.") : "");
        return isValid;
    };
    const handleContact1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setContact1(e.target.value);
        validateContact1(e.target.value);
    };
    const validateContact1 = (value: string) => {
        const isValid = isNonEmptyString(value);
        setContact1Error(!isValid ? translate("Contact 1 is required.") : "");
        return isValid;
    };
    const validateAcct1 = (value: string) => {
        const isValid = isNonEmptyString(value);
        setAcct1Error(!isValid ? translate("Contact 1 is required.") : "");
        return isValid;
    };
    const handleAcc1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAcct1(e.target.value);
        validateAcct1(e.target.value);
    };
    const handleContact3Change = (e: React.ChangeEvent<HTMLInputElement>) => {
        setContact3(e.target.value);
        validateContact3(e.target.value);
    };
    const validateContact3 = (value: string) => {
        const isValid = isNonEmptyString(value);
        setContact3Error(!isValid ? translate("Contact 3 is required.") : "");
        return isValid;
    };
    const fileChangeHandlerEPA = (event: React.ChangeEvent<any>) => {
        const uploadedFiles = event.target.files?.[0];
        if (uploadedFiles) {
            validateUploadedFileEPA(uploadedFiles);
            setFileEPA(uploadedFiles);
        } else {
            validateUploadedFileEPA("");
            setFileEPA("");
        }
    };

    const validateUploadedFileEPA = (file: any) => {
        const fileExtension = file ? getFileExtension(file.name) : "";
        const allowedExtensions = ["pdf"];
        const incorrectFileExtension = file && !allowedExtensions.includes(fileExtension);
        const maxFileSizeMB = fields.maxFileSize; // Maximum file size in MB
        const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;
        const fileTooLarge = file && file.size > maxFileSizeBytes;

        const FileUploadEPAerror = !file
            ? uploadFileMessageEPA
            : incorrectFileExtension
              ? translate("File must be .pdf format")
              : fileTooLarge
                ?  siteMessage("FileSize_Error")
                : "";

        setFileUploadEPAerror(FileUploadEPAerror);
        return !FileUploadEPAerror;
    };
    const resetAllFields = () => {
        // Personal Info
        setPerName("");
        setPerEmail("");

        // Billing Info
        setbTCompanyName("");
        setbTAddress1("");
        setAddress2("");
        setbTCityChange("");
        setbTState("");
        setbTpostalCode("");
        setBillingPhone("");
        setBillingApContact("");
        setBillingSicCode("");
        setBillingDnBNumber("");
        setbTAddressAutocomplete([]);

        // Shipping Info
        setShippingCompanyName("");
        setShippingAddress("");
        setShippingAddress2("");
        setShippingCity("");
        setShippingState("");
        setShippingPostalCode("");
        setShippingPhone("");
        setShippingFax(""); // optional
        setShippingAddressAutocomplete([]);

        // Bank Info
        setBankName("");
        setBankAddress("");
        setBankAddress2("");
        setBankCity("");
        setBankPostalCode("");
        setCheckingAccount1("");
        setCheckingAccount2("");
        setLoanAccount1("");
        setLoanAccount2("");
        setBankContact("");
        setBankPhone("");
        setBankAddressAutocomplete([]);

        // Trade References
        setFirmName1("");
        setContact1("");
        setAcct1("");
        setFirmName2("");
        setContact2("");
        setAcct2("");
        setFirmName3("");
        setContact3("");
        setAcct3("");
        setFileEPA("");
    };

    const payload: CreditCardFormRequest = {
        // Personal Info
        name: perName,
        email: perEmail,

        // Billing Info
        bTName: bTcompanyName,
        bTAddress1: bTaddress1,
        bTAddress2: address2, // optional
        bTCity: bTcity,
        bTState: bTstate?.abbreviation,
        bTPostalCode: bTpostalCode,
        bTPhone: billingPhone,
        bTFaxNumber: fax, // optional
        sicCode:billingSicCode,
        typeOfBusiness: businessType, // optional
        apContact: billingApContact,
        invoiceEmail: emailforInvoice, // optional
        dunsNumber: billingDnBNumber,
        isReseller,

        // Shipping Info
        sTName: shippingCompanyName,
        sTAddress1: shippingAddress,
        sTAddress2: shippingAddress2, // optional
        sTCity: shippingCity,
        sTState: shippingState?.abbreviation,
        sTPostalCode: shippingPostalCode,
        sTPhone: shippingPhone,
        sTFaxNumber: shippingFax, // optional

        // Bank Info
        bankName,
        bankAddress1: bankAddress,
        bankAddress2, // optional
        bankCity,
        bankState: bankState?.abbreviation, // optional
        bankPostalCode,
        checkingAccountNumber1: checkingAccount1,
        checkingAccountNumber2: checkingAccount2,
        loanAccountNumber1: loanAccount1,
        loanAccountNumber2: loanAccount2,
        bankContact,
        bankPhoneNumber: bankPhone,
        attachment:isTaxExempt? fileEPA :"", // if any

        // Trade References
        tradeReferences: [
            {
                firmName: firmName1,
                contact: contact1,
                accountNumber: acct1,
            },
            {
                firmName: firmName2,
                contact: contact2,
                accountNumber: acct2,
            },
            {
                firmName: firmName3,
                contact: contact3,
                accountNumber: acct3,
            },
        ],
    };

    const handleFormSubmit = () => {
      
        if (!isSubmitted) {
            setIsSubmitted(true);
        }
        if (!validateForm()) {
            setFormErrors(true);
              return;
        }
         setIsLoading(true);
        creditCardFormHandler({
            ...payload,
          onSuccess(result) {
                setIsModalOpen(true);
             resetAllFields();
               setIsLoading(false);
          },
          onError(error) {
               setIsLoading(false);
          },

        });

    };
    const modalCloseHandler = () => {
        setIsModalOpen(false);
    };
    const modalCloseHandlerButton = () => {
        window.location.href = homePageUrl;
    };
        const handleCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
            setIsTaxExempt(value); 
            if(!value){
                 setFileUploadEPAerror("");
            }
        }
        const handleResellerCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
            setIsReseller(value); 
           
        }
        const handleBusinessTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = event.target.value; // This is the selected business type
    setBussinesstype(selectedType); // assuming bTstate is a string in state
};

    return (
        <GridContainer {...styles.containerCustom} data-test-selector="creditCardApplicationFormFields">
            <Typography variant="h1" {...styles.title}>{siteMessage("Centro's Credit Application ")}</Typography>
          { isLoading&&  <>
         <StyledWrapper {...styles.centeringWrapper}>
                                                    <LoadingSpinner {...styles.spinner} />
                                                </StyledWrapper>
           </>}
            {!isLoading&& ( <>
            
            <GridContainer {...styles.checkboxWrapper}>
                <GridItem {...checkboxGridItemFinal}>
                    <Checkbox
                        // onChange={() => setIsTaxExempt(!isTaxExempt)}
                          onChange={handleCheckboxChange}
                        checked={isTaxExempt}
                        {...styles.checkboxStyle}
                    >
                        {translate("Tax Exempt")}
                    </Checkbox> 


              
                    {isTaxExempt && (
                        <StyledWrapper {...styles.fileUploaderContainer}>
                            <FileUpload
                                {...styles.fileUploader}
                                inputRef={fileUploadRef}
                                fileName={fileEPA?.name || ""}
                                accept=".pdf"
                                label={translate("Attach Tax Exemption Certificate")}
                                labelPosition="top"
                                error={(fileEPA || isSubmitted) && FileUploadEPAerror}
                                onFileChange={fileChangeHandlerEPA}
                                uid="orderUploadFileUpload"
                            />
                            {!fileEPA && (
                                <Typography>
                                     {siteMessage("UploadFile_Message",`${fields.maxFileSize}`)}
                                </Typography>
                            )}
                        </StyledWrapper>
                    )}
                </GridItem>
                   <GridItem {...checkboxGridItemFinal}>
                    <Checkbox
                       
                          onChange={handleResellerCheckboxChange}
                        checked={isReseller}
                        {...styles.checkboxStyle}
                    >
                        {translate("Reseller")}
                    </Checkbox> 
                   </GridItem>
            </GridContainer>
            <>
                <Typography
                    variant="h3"
                    css={css`
                         padding: 15px 15px 9px 15px;
                         margin-bottom: 0px;
                        margin-top:33px;
                        width: 100%;
                    `}
                >
                    {siteMessage("Personal Information")}
                </Typography>
                <GridItem {...styles.phoneGridItemCustom}>
                    <TextField
                        {...styles.companyNameCustomText}
                        name="FirstName"
                        label={siteMessage(" Name ")}
                        value={perName}
                        required
                        maxLength={100}
                        onChange={handlePerNameChange}
                        error={perNameError}
                        data-test-selector="customerAddressForm_firstName"
                    />
                </GridItem>

                <GridItem {...styles.phoneGridItemCustom}>
                    <TextField
                        {...styles.addressText}
                        name="PerEmail"
                        label={siteMessage("Email")}
                        value={perEmail}
                        required
                        maxLength={100}
                        onChange={event => handlePerEmailChange(event.target.value)}
                        error={perEmailError}
                        data-test-selector="customerAddressForm_lastName"
                    />
                </GridItem>
            </>
            <>
                <Typography
                    variant="h3"
                    css={css`
                       padding: 15px 15px 9px 15px;
                         margin-bottom: 0px;
                        margin-top:18px;
                        width:100%;
                    `}
                >
                    {siteMessage("Billing Information")}
                </Typography>

                <GridItem {...styles.companyName}>
                    <TextField
                        {...styles.companyNameCustomText}
                        name="companyName"
                        label={siteMessage("Company Name ")}
                        value={bTcompanyName}
                        required
                        maxLength={100}
                        onChange={bThandleCompanyNameChange}
                        error={companyNameError}
                        data-test-selector="customerAddressForm_firstName"
                    />
                </GridItem>

                <GridItem {...styles.address}>
                    <TextField
                        {...styles.addressText}
                        name="Address"
                        label={siteMessage("Address")}
                        value={bTaddress1}
                        required
                        maxLength={100}
                        onChange={bThandleAddressChange}
                        error={bTaddress1Error}
                        data-test-selector="customerAddressForm_lastName"
                    />

                    {bTaddressAutocomplete && bTaddressAutocomplete.length > 0 && (
                        <StyledWrapper as="ul" {...styles.addressList}>
                            {bTaddressAutocomplete.map((address) => (
                                <StyledWrapper as="li" key={address.street_line} onClick={() => updateBTAddress(address)}>
                                    {`${address.street_line}, ${address.city}`}
                                </StyledWrapper>
                            ))}
                        </StyledWrapper>
                    )}
                </GridItem>
                {!isAddress2Opened ? (
                    <GridItem {...styles.address2}>
                        <Link
                            {...styles.addAddressLineLink}
                            onClick={() => setIsAddress2Opened(true)}
                            data-test-selector="customerAddressForm_addressLine2"
                        >
                            {translate("+ Address line 2")}
                        </Link>
                    </GridItem>
                ) : (
                    <>
                        <GridItem {...styles.address}>
                            <TextField
                                {...styles.addressText}
                                name="address2"
                                label="Address2"
                                value={address2}
                                maxLength={100}
                                onChange={handleAddress2Change}
                                error={address2Error}
                                data-test-selector="customerAddressForm_address2"
                            />
                        </GridItem>
                        <GridItem {...styles.address}>
                            <Link
                                {...styles.addAddressLineLink}
                                onClick={() => setIsAddress2Opened(false)}
                                data-test-selector="customerAddressForm_addressLine2"
                            >
                                {translate("- Address line 2")}
                            </Link>
                        </GridItem>
                    </>
                )}

                <GridItem {...styles.cityGridItemCustom}>
                    <TextField
                        {...styles.cityTextCustom}
                        name="city"
                        label={siteMessage("City")}
                        value={bTcity}
                        required
                         maxLength={30}
                        onChange={bThandleCityChange}
                        error={bTcityError}
                        data-test-selector="customerAddressForm_city"
                    />
                </GridItem>

                <GridItem {...styles.stateGridItemCustom}>
                    <Select
                        {...styles.stateSelectCustom}
                        label={siteMessage("State")}
                        value={bTstate?.id || ""}
                        required
                        onChange={handleStateChange}
                        error={bTstateError}
                        data-test-selector="customerAddressForm_state"
                    >
                        <option value="">{translate("Select State")}</option>
                        {states.map(st => (
                            <option key={st.id} value={st.id}>
                                {st.name}
                            </option>
                        ))}
                    </Select>
                </GridItem>
                <GridItem {...styles.postalCodeGridItemCustom}>
                    <TextField
                        {...styles.postalCodeTextCustom}
                        name="postalCode"
                        label={siteMessage("Postal Code")}
                        value={bTpostalCode}
                        required
                        maxLength={5}
                        onChange={bThandlePostalChange}
                        error={bTpostalCodeError }
                        data-test-selector="customerAddressForm_postalCode"
                    />
                </GridItem>

                <GridItem {...styles.phoneGridItemCustom}>
                    <TextField
                        {...styles.phoneTextCustom}
                        name="phone"
                        label={siteMessage("Phone Number")}
                        value={billingPhone}
                        required
                         maxLength={15}
                        onChange={handleBillingPhoneChange}
                        error={billingPhoneError}
                        data-test-selector="customerAddressForm_phone"
                    />
                </GridItem>

                <GridItem {...styles.faxGridItemCustom}>
                    <TextField
                        {...styles.faxTextCustom}
                        name="fax"
                        label={siteMessage("Cred Fax")}
                        value={fax}
                        onChange={handleFaxChange}
                        data-test-selector="customerAddressForm_fax"
                    />
                </GridItem>

                <GridItem {...styles.sicCodeGridItem}>
                    <TextField
                        {...styles.sicCodeTextCustom}
                        name="SIC Code (or type of business)"
                        label={siteMessage("SIC Code (or type of business)")}
                        value={billingSicCode}
                        onChange={handleBillingSicCodeChange}
                        data-test-selector="customerAddressForm_SicCode"
                    />
                </GridItem>
                
                <GridItem {...styles.sicCodeGridItem}>
                    <Select
                        {...styles.stateSelectCustom}
                       label={siteMessage(" Type of business")}
                        value={businessType|| ""}
                        
                        onChange={handleBusinessTypeChange}
                        error={bTstateError}
                        data-test-selector="customerAddressForm_state"
                    >
                        <option value="">{translate("Select Type")}</option>
                        {bussinesTypes.map((type, index) => (
            <option key={index} value={type}>
                {type}
            </option>
        ))}
                    </Select>
                </GridItem>

                <GridItem {...styles.apContactItem}>
                    <TextField
                        {...styles.apContactText}
                        name="AP Contact"
                        label={siteMessage("AP Contact")}
                        value={billingApContact}
                        required
                        onChange={handleBillingApContactChange}
                        error={billingApContactError}
                        data-test-selector="customerAddressForm_apContact"
                    />
                </GridItem>
                <GridItem {...styles.emailGridItemCustom}>
                    <TextField
                        {...styles.emailTextCustom}
                        name="email"
                        label={siteMessage("Email for Invoices")}
                        value={emailforInvoice}
                        required
                        onChange={event => emailChangeHandler(event.target.value)}
                        error={emailInvoiceError}
                        data-test-selector="customerAddressForm_email"
                    />
                </GridItem>
                <GridItem {...styles.invoiceTermsGridItem}>
                    <StyledWrapper {...styles.innerContainer}>
                        <Icon
                            src={CENCreditCardDollarIcon}
                        />
                        <StyledWrapper>
                            {siteMessage("Invoice Terms")}
                        </StyledWrapper>
                    </StyledWrapper>
                    <StyledWrapper {...styles.innerContainer}>
                        <Icon
                            src={CreditCardTruckIcon}
                        />
                        <StyledWrapper>
                            {siteMessage("Freight Terms")}
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.bradstreetGridItem}>
                    <TextField
                        {...styles.bradstreetText}
                        name="Dunn & Bradstreet #"
                        label={siteMessage("Dunn & Bradstreet #")}
                        value={billingDnBNumber}
                         maxLength={9}
                         error={billingDnBNumberError}
                        onChange={handleBillingDnBNumberChange}
                        data-test-selector="customerAddressForm_email"
                    />
                </GridItem>
            </>
            <>
                <Typography
                    variant="h3"
                    css={css`
                        padding: 15px 15px 9px 15px;
                         margin-bottom: 0px;
                        margin-top:18px;
                    `}
                >
                    {siteMessage("Shipping Information")}
                </Typography>

                <GridItem {...styles.companyName}>
                    <TextField
                        {...styles.companyNameCustomText}
                        name="shippingCompanyName"
                        label={siteMessage("Company Name")}
                        required
                        value={shippingCompanyName}
                        onChange={handleShippingCompanyNameChange}
                        error={shippingCompanyNameError}
                    />
                </GridItem>

                <GridItem {...styles.address}>
                    <TextField
                        {...styles.addressText}
                        name="shippingAddress"
                        required
                        label={siteMessage("Address")}
                        value={shippingAddress}
                        onChange={handleShippingAddressChange}
                        error={shippingAddressError}
                    />

                    {shippingAddressAutocomplete && shippingAddressAutocomplete.length > 0 && (
                        <StyledWrapper as="ul" {...styles.addressList}>
                            {shippingAddressAutocomplete.map((address) => (
                                <StyledWrapper as="li" key={address.street_line} onClick={() => updateShippingAddress(address)}>
                                    {`${address.street_line}, ${address.city}`}
                                </StyledWrapper>
                            ))}
                        </StyledWrapper>
                    )}
                </GridItem>
             {!isshippingAddress2Opened ? (
                                                        <GridItem {...styles.address2}>
                                                            <Link
                                                                {...styles.addAddressLineLink}
                                                                onClick={() => setIsShippingAddress2Opened(true)}
                                                                data-test-selector="customerAddressForm_addressLine2"
                                                            >
                                                                {translate("+ Address line 2")}
                                                            </Link>
                                                        </GridItem>
                                                    ) : (
                                                        <>
                                                            <GridItem {...styles.address2}>
                                                                <TextField
                                                                    {...styles.addressText}
                                                                    name="address2"
                                                                    label="Address2"
                                                                    value={shippingAddress2}
                                                                    maxLength={100}
                                                                    onChange={handleShippingAddress2Change}
                                                                    
                                                                    data-test-selector="customerAddressForm_address2"
                                                                />
                                                            </GridItem>
                                                            <GridItem {...styles.address2}>
                                                                <Link
                                                                    {...styles.addAddressLineLink}
                                                                    onClick={() => setIsShippingAddress2Opened(false)}
                                                                    data-test-selector="customerAddressForm_addressLine2"
                                                                >
                                                                    {translate("- Address line 2")}
                                                                </Link>
                                                            </GridItem>
                                                        </>
                                                    )}
                <GridItem {...styles.cityGridItemCustom}>
                    <TextField
                        {...styles.cityTextCustom}
                        name="shippingCity"
                        label={siteMessage("City")}
                        value={shippingCity}
                        required
                        onChange={handleShippingCityChange}
                        error={shippingCityError}
                    />
                </GridItem>

                <GridItem {...styles.stateGridItemCustom}>
                    <Select
                        {...styles.stateSelectCustom}
                        label={siteMessage("State")}
                        value={shippingState?.id}
                        required
                        onChange={handleShippingStateChange}
                          error={shippingStateError}
                        data-test-selector="customerAddressForm_state"
                    >
                        <option value="">{translate("Select State")}</option>
                        {states.map(st => (
                            <option key={st.id} value={st.id}>
                                {st.name}
                            </option>
                        ))}
                    </Select>
                </GridItem>

                <GridItem {...styles.postalCodeGridItemCustom}>
                    <TextField
                        {...styles.postalCodeTextCustom}
                        name="shippingPostalCode"
                        label={siteMessage("Postal Code")}
                        required
                        value={shippingPostalCode}
                        onChange={handleShippingPostalCodeChange}
                        error={shippingPostalCodeError}
                    />
                </GridItem>

                <GridItem {...styles.phoneGridItemCustom}>
                    <TextField
                        {...styles.phoneTextCustom}
                        name="shippingPhone"
                        label={siteMessage("Phone Number")}
                        value={shippingPhone}
                        required
                        onChange={handleShippingPhoneChange}
                        error={shippingPhoneError}
                    />
                </GridItem>

                <GridItem {...styles.faxGridItemCustom}>
                    <TextField
                        {...styles.faxTextCustom}
                        name="shippingFax"
                        label={siteMessage("Cred Fax")}
                        value={shippingFax}
                        onChange={handleShippingFaxChange}
                    />
                </GridItem>
            </>
            <>
                <Typography
                    variant="h3"
                    css={css`
                        padding: 15px 15px 9px 15px;
                         margin-bottom: 0px;
                        margin-top:18px;
                    `}
                >
                    {siteMessage("Bank Reference")}
                </Typography>

                <GridItem {...styles.companyName}>
                    <TextField
                        {...styles.companyNameCustomText}
                        name="bankName"
                        label={siteMessage("Name of Bank")}
                        value={bankName}
                        onChange={handleBankNameChange}
                    />
                </GridItem>

                <GridItem {...styles.address}>
                    <TextField
                        {...styles.addressText}
                        name="bankAddress"
                        label={siteMessage("Address")}
                        value={bankAddress}
                        onChange={handleBankAddressChange}
                    />

                    {bankAddressAutocomplete && bankAddressAutocomplete.length > 0 && (
                        <StyledWrapper as="ul" {...styles.addressList}>
                            {bankAddressAutocomplete.map((address) => (
                                <StyledWrapper as="li" key={address.street_line} onClick={() => updateBankAddress(address)}>
                                    {`${address.street_line}, ${address.city}`}
                                </StyledWrapper>
                            ))}
                        </StyledWrapper>
                    )}
                </GridItem>
                {!isBankAddress2Opened ? (
                                                        <GridItem {...styles.address2}>
                                                            <Link
                                                                {...styles.addAddressLineLink}
                                                                onClick={() => setIsBankAddress2Opened(true)}
                                                                data-test-selector="customerAddressForm_addressLine2"
                                                            >
                                                                {translate("+ Address line 2")}
                                                            </Link>
                                                        </GridItem>
                                                    ) : (
                                                        <>
                                                            <GridItem {...styles.address2}>
                                                                <TextField
                                                                    {...styles.addressText}
                                                                    name="address2"
                                                                    label="Address2"
                                                                    value={bankAddress2}
                                                                    maxLength={100}
                                                                    onChange={handleBankAddress2Change}
                                                                  
                                                                    data-test-selector="customerAddressForm_address2"
                                                                />
                                                            </GridItem>
                                                            <GridItem {...styles.address2}>
                                                                <Link
                                                                    {...styles.addAddressLineLink}
                                                                    onClick={() => setIsBankAddress2Opened(false)}
                                                                    data-test-selector="customerAddressForm_addressLine2"
                                                                >
                                                                    {translate("- Address line 2")}
                                                                </Link>
                                                            </GridItem>
                                                        </>
                                                    )}

                <GridItem {...styles.cityGridItemCustom}>
                    <TextField
                        {...styles.cityTextCustom}
                        name="bankCity"
                        label={siteMessage("City")}
                        value={bankCity}
                        required
                        onChange={handleBankCityChange}
                        error={bankCityError}
                    />
                </GridItem>

                <GridItem {...styles.stateGridItemCustom}>
                    <Select
                        {...styles.stateSelectCustom}
                        label={siteMessage("Bank State")}
                        value={bankState?.id || ""}
                        // disabled={validation.state!.isDisabled}
                        onChange={handleBankStateChange}
                        //  error={bTstateError}
                        data-test-selector="customerAddressForm_state"
                    >
                        <option value="">{translate(" Select State")}</option>
                        {states.map(st => (
                            <option key={st.id} value={st.id}>
                                {st.name}
                            </option>
                        ))}
                    </Select>
                </GridItem>

                <GridItem {...styles.postalCodeGridItemCustom}>
                    <TextField
                        {...styles.postalCodeTextCustom}
                        name="bankPostalCode"
                        label={siteMessage("Bank Postal Code")}
                        value={bankPostalCode}
                        onChange={handleBankPostalCodeChange}
                    />
                </GridItem>

                <GridItem {...styles.checkingAccount1}>
                    <TextField
                        {...styles.checkingAccount1Text}
                        name="checkingAccount1"
                        label={siteMessage("Checking Account Number 1")}
                        value={checkingAccount1}
                        onChange={handleCheckingAccount1Change}
                    />
                </GridItem>

                <GridItem {...styles.checkingAccount2}>
                    <TextField
                        {...styles.checkingAccount2Text}
                        name="checkingAccount2"
                        label={siteMessage("Checking Account Number 2")}
                        value={checkingAccount2}
                        onChange={handleCheckingAccount2Change}
                    />
                </GridItem>

                <GridItem {...styles.loanAccount1}>
                    <TextField
                        {...styles.loanAccount1Text}
                        name="loanAccount1"
                        label={siteMessage("Loan Account Number 1")}
                        value={loanAccount1}
                        onChange={handleLoanAccount1Change}
                    />
                </GridItem>

                <GridItem {...styles.loanAccount2}>
                    <TextField
                        {...styles.loanAccount2Text}
                        name="loanAccount2"
                        label={siteMessage("Loan Account Number 2")}
                        value={loanAccount2}
                        onChange={handleLoanAccount2Change}
                    />
                </GridItem>

                <GridItem {...styles.bankContact}>
                    <TextField
                        {...styles.bankContactText}
                        name="bankContact"
                        label={siteMessage("Bank Contact")}
                        value={bankContact}
                        onChange={handleBankContactChange}
                    />
                </GridItem>

                <GridItem {...styles.bankPhone}>
                    <TextField
                        {...styles.bankPhoneText}
                        name="bankPhone"
                        label={siteMessage("Bank Phone Number")}
                        value={bankPhone}
                        onChange={handleBankPhoneChange}
                    />
                </GridItem>
            </>

            <>
                <Typography
                    variant="h3"
                    css={css`
                        padding: 15px 15px 9px 15px;
                         margin-bottom: 0px;
                        margin-top:18px;
                    `}
                >
                    {siteMessage("Trade Reference")}
                </Typography>

                {/* -------- Trade Reference 1 -------- */}
                <GridItem {...styles.companyName}>
                    <TextField
                        {...styles.companyNameCustomText}
                        name="firmName1"
                        label={siteMessage("Firm Name 1")}
                        value={firmName1}
                        required
                        onChange={handleFirmName1Change}
                        error={firmName1Error}
                    />
                </GridItem>

                <GridItem {...styles.phoneGridItemCustom}>
                    <TextField
                        {...styles.phoneTextCustom}
                        name="contact1"
                        label={siteMessage("Contact 1")}
                        required
                        value={contact1}
                        onChange={handleContact1Change}
                        error={contact1Error}
                    />
                </GridItem>

                <GridItem {...styles.phoneGridItemCustom}>
                    <TextField
                        {...styles.phoneTextCustom}
                        name="acct1"
                        label={siteMessage("Acct 1")}
                        required
                        value={acct1}
                        onChange={handleAcc1Change}
                        error={acct1Error}
                    />
                </GridItem>

                {/* -------- Trade Reference 2 -------- */}
                <GridItem {...styles.companyName}>
                    <TextField
                        {...styles.companyNameCustomText}
                        name="firmName2"
                        label={siteMessage("Firm Name2")}
                        value={firmName2}
                        required
                        onChange={handleFirmName2Change}
                        error={firmName2Error}
                    />
                </GridItem>

                <GridItem {...styles.phoneGridItemCustom}>
                    <TextField
                        {...styles.phoneTextCustom}
                        name="contact2"
                        label={siteMessage("Contact 2")}
                        value={contact2}
                        required
                        onChange={handleContact2Change}
                        error={contact2Error}
                    />
                </GridItem>

                <GridItem {...styles.phoneGridItemCustom}>
                    <TextField
                        {...styles.phoneTextCustom}
                        name="acct2"
                        label={siteMessage("Acct 2")}
                        value={acct2}
                        required
                        onChange={handleaccount2Change}
                        error={acct2Error}
                    />
                </GridItem>

                {/* -------- Trade Reference 3 -------- */}
                <GridItem {...styles.companyName}>
                    <TextField
                        {...styles.companyNameCustomText}
                        name="firmName3"
                        label={siteMessage("Firm Name 3")}
                        value={firmName3}
                        required
                        onChange={handleFirmName3Change}
                        error={firmName3Error}
                    />
                </GridItem>

                <GridItem {...styles.phoneGridItemCustom}>
                    <TextField
                        {...styles.phoneTextCustom}
                        name="contact3"
                        label={siteMessage("Contact 3")}
                        value={contact3}
                        required
                        onChange={handleContact3Change}
                        error={contact3Error}
                    />
                </GridItem>

                <GridItem {...styles.phoneGridItemCustom}>
                    <TextField
                        {...styles.phoneTextCustom}
                        name="acct3"
                        label={siteMessage("Acct #")}
                        value={acct3}
                        required
                        onChange={handleaccount3Change}
                        error={acct3Error}
                    />
                </GridItem>
            </>
 {(hasAnyError() && isSubmitted) &&
             <StyledWrapper {...styles.submitError}>
                <Typography>{siteMessage("Please fill out all required fields")}</Typography>
            </StyledWrapper>}
            <StyledWrapper {...styles.submitButtonCustom}>
                <Button
                    type="submit"
                    data-test-selector="customerAddressForm_save"
                    onClick={() => handleFormSubmit()}
                    variant="secondary"
                >
                    {translate("Submit Application")}
                </Button>
            </StyledWrapper>
           

            <Modal
                isOpen={isModalOpen}
                headline={translate("Centro’s Credit Application")}
                handleClose={modalCloseHandler}
                as="h3"
                {...styles.modalStyle}
            >
                <StyledWrapper {...styles.modalWrapper}>
                    <Typography>{translate("Centro’s Credit Application Submitted Successfully.")}</Typography>

                    <Button type="button" onClick={modalCloseHandlerButton} {...styles.okButton}>
                        {translate("Close")}
                    </Button>
                </StyledWrapper>
            </Modal></>)}
        </GridContainer>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CENCreditCardAppForm),
    definition: {
        group: "Basic",
        displayName: "CEN Credit Application Form",
         fieldDefinitions: [
            {
                fieldType: "Contextual",
                name: fields.maxFileSize,
                editorTemplate: "TextField",
                displayName: "Max File Size",
                defaultValue: "5",
            },]
    },
};
export default widgetModule;
